import React from 'react';

import { ChocoCheckbox } from '../../../../../../../components/FormComponents';

interface PreferenceToggleProps {
  label: string;
  description: string;
  isSelected: boolean;
  onChange: (isSelected: boolean) => void;
  disabled?: boolean;
}

export const PreferenceToggle: React.FC<PreferenceToggleProps> = ({
  label,
  description,
  isSelected,
  onChange,
  disabled = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = Boolean(e.target.checked);
    onChange(checked);
  };

  return (
    <div className="flex items-center mx-8">
      <div className="flex-1">
        <p className="font-medium">{label}</p>
        <p className="text-sm text-default-500">{description}</p>
      </div>
      <ChocoCheckbox
        id={label}
        // The label sits in the row beside the control rather than inside it, so
        // the checkbox has no name of its own without this.
        aria-label={label}
        checked={isSelected}
        onChange={handleChange}
        isDisabled={disabled}
        isSelected={isSelected}
        color="primary"
      />
    </div>
  );
};
